exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-5d6d9866] {\n  background-color: #f8f8f8;\n}", ""]);

// exports
